import { render } from "./RegularMountCheckbox.vue?vue&type=template&id=0f9907a8"
import script from "./RegularMountCheckbox.vue?vue&type=script&lang=js"
export * from "./RegularMountCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__